<div class="container-fuid sub-header d-flex align-items-center">
    <div class="w-100">
        <nav aria-label="breadcrumb" class="align-items-center">
            <app-settings-subheader></app-settings-subheader>
        </nav>
    </div>
</div>

<div class="container-fuid ms-3 me-2 mt-2 mx-md-5 mt-md-3 mx-lg-5 mt-lg-5">
    <div class="row row-cols-12 row-cols-sm-12 row-cols-md-12 row-cols-lg-12 row-cols-xl-12 row-cols-xxl-12">
        <div
            class="p-1 d-none d-lg-block offset-0 offset-sm-0 offset-md-0 offset-lg-0 offset-xl-0 offset-xxl-2 col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-2">
            <settings-navigation></settings-navigation>
        </div>
        <div class="p-1 col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-6">
            <div class="default-boxshadow bg-white default-boxrounded p-2 h-100">
                <ng-container *ngIf="!isLoading">
                    <router-outlet></router-outlet>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<app-mobile-overlay></app-mobile-overlay>